export const LIST_RESULT_CATEGORY_REQUEST = 'LIST_RESULT_CATEGORY_REQUEST'
export const LIST_RESULT_CATEGORY_SUCCESS = 'LIST_RESULT_CATEGORY_SUCCESS'
export const LIST_RESULT_CATEGORY_FAIL = 'LIST_RESULT_CATEGORY_FAIL'
export const LIST_RESULT_CATEGORY_RESET = 'LIST_RESULT_CATEGORY_RESET'

export const LIST_RESULT_CATEGORY_SUMMARY_REQUEST = 'LIST_RESULT_CATEGORY_SUMMARY_REQUEST'
export const LIST_RESULT_CATEGORY_SUMMARY_SUCCESS = 'LIST_RESULT_CATEGORY_SUMMARY_SUCCESS'
export const LIST_RESULT_CATEGORY_SUMMARY_FAIL = 'LIST_RESULT_CATEGORY_SUMMARY_FAIL'
export const LIST_RESULT_CATEGORY_SUMMARY_RESET = 'LIST_RESULT_CATEGORY_SUMMARY_RESET'

export const CREATE_RESULT_CATEGORY_REQUEST = 'CREATE_RESULT_CATEGORY_REQUEST'
export const CREATE_RESULT_CATEGORY_SUCCESS = 'CREATE_RESULT_CATEGORY_SUCCESS'
export const CREATE_RESULT_CATEGORY_FAIL = 'CREATE_RESULT_CATEGORY_FAIL'

export const DETAIL_RESULT_CATEGORY_REQUEST = 'DETAIL_RESULT_CATEGORY_REQUEST'
export const DETAIL_RESULT_CATEGORY_SUCCESS = 'DETAIL_RESULT_CATEGORY_SUCCESS'
export const DETAIL_RESULT_CATEGORY_FAIL = 'DETAIL_RESULT_CATEGORY_FAIL'

export const UPDATE_RESULT_CATEGORY_REQUEST = 'UPDATE_RESULT_CATEGORY_REQUEST'
export const UPDATE_RESULT_CATEGORY_SUCCESS = 'UPDATE_RESULT_CATEGORY_SUCCESS'
export const UPDATE_RESULT_CATEGORY_FAIL = 'UPDATE_RESULT_CATEGORY_FAIL'

export const DELETE_RESULT_CATEGORY_REQUEST = 'DELETE_RESULT_CATEGORY_REQUEST'
export const DELETE_RESULT_CATEGORY_SUCCESS = 'DELETE_RESULT_CATEGORY_SUCCESS'
export const DELETE_RESULT_CATEGORY_FAIL = 'DELETE_RESULT_CATEGORY_FAIL'

export const RESET_RESULT_CATEGORY = 'RESET_RESULT_CATEGORY'
